import { render } from "./employee.vue?vue&type=template&id=d36030e0"
import script from "./employee.vue?vue&type=script&lang=js"
export * from "./employee.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/appointments/employee.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d36030e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d36030e0', __exports__)) {
    console.log('reload')
    api.reload('d36030e0', __exports__)
  }
  
  module.hot.accept("./employee.vue?vue&type=template&id=d36030e0", () => {
    console.log('re-render')
    api.rerender('d36030e0', render)
  })

}


export default __exports__